import {
  formatNumber,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';
import InnerCircleText from '../InnerCircleText';
import SevenStarsInnerCircle from '../SevenStarsInnerCircle/SevenStarsInnerCircle';

export interface InnerCircleProps {
  tierCredits: number;
}

const InnerCircle: React.FC<InnerCircleProps> = ({tierCredits}) => {
  const theme = useTheme() as any;
  const {white, shuttleGray} = theme.colors;

  return (
    <View justifyContent="center" alignItems="center">
      <Text
        fontFamily="heading"
        fontSize="18px"
        fontWeight="bold"
        lineHeight="25px"
        color={shuttleGray}
        pb="4px">
        {tierCredits ? formatNumber(tierCredits) : 0}
      </Text>
      <InnerCircleText text="Tier Credits" isSevenStars={false} />
    </View>
  );
};

export default InnerCircle;
